import { render, staticRenderFns } from "./dfk.vue?vue&type=template&id=a8a26416&scoped=true&"
import script from "./dfk.vue?vue&type=script&lang=js&"
export * from "./dfk.vue?vue&type=script&lang=js&"
import style0 from "./dfk.vue?vue&type=style&index=0&id=a8a26416&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a26416",
  null
  
)

export default component.exports